export default __webpack_public_path__ + "static/media/icn-brakejaws-vehicle.86f8dffd.svg";